import { Stack, Typography } from '@mui/material';

interface Props {
  title: string;
  values: Array<string>;
}

const InfoListDisplay = ({ title, values }: Props) => {
  return (
    <Stack
      spacing={0.5}
      sx={{
        flex: 1,
      }}
    >
      <Typography
        variant="extraSmall"
        sx={{
          fontWeight: 500,
          color: 'grey.500',
        }}
      >
        {title}
      </Typography>
      {values.map((item, index) => (
        <Typography
          key={index}
          variant="extraSmall"
          sx={{
            fontWeight: 'bold',
          }}
        >
          {item}
        </Typography>
      ))}
    </Stack>
  );
};

export default InfoListDisplay;
